export const ATTENDANCE_CONTROL_USERS_TYPES = {
  USER: 'u',
  SUPERVISOR: 's',
};
